import { render, staticRenderFns } from "./TechList.vue?vue&type=template&id=18bfc58c&scoped=true&"
import script from "./TechList.vue?vue&type=script&lang=js&"
export * from "./TechList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bfc58c",
  null
  
)

export default component.exports